export const API_ENDPOINTS = {
  GET_ALL_DOCTOR: "/master/getAllDoctors",
  SEARCH_ALL: "master/searchDocSpecBranch",
  GET_ALL_SPECIALITY: "master/getAllSpecializations",

  GET_DOCTOR_BY_SPECIALITY: "master/filterDoctorsBySpecialization",
  DOCTOR_BY_ID: "master/getDoctorDetailsById",

  DOCTOR_AVAILABLE_SLOT: "master/getAvailableDoctorSlots",
  GUEST_BOOKING: "appointment/guest/bookAppointment",
  LOGIN_BOOKING: "appointment/bookAppointment",

  USER_DETAILS: "user/getUserDetails",
  APPOINTMENT_HISTORY: "appointment/appointmentHistory",
  UPCOMMING_APPOINTMENT: "appointment/upcomingAppointments",
  RESCHEDULE_APPOINTMENT: "appointment/rescheduleAppointment",
  CANCEL_APPOINTMENT: "appointment/cancelAppointment",

  MEDICAL_RECORDS: "medicalRecord/getMedicalRecords",
  BILLING: "billing/getBillingDetails",

  // LOGIN

  SEND_OTP: "auth/sendOtp",
  VERIFY_OTP: "auth/verifyOtp",
  SET_PASSWORD: "auth/Password",
  CREATE_ACCOUNT: "auth/userProfile",
  LOGIN_USER: "auth/login",

  GET_SPECIAL_PACKAGES: "package/getAllSpecialPackages",
  CREATE_BOOK_PACKAGE: "package/createBookingPackage",
  GET_BOOKED_PACKAGE_ID: "package/getBookingPackageDetailsById",
  CREATE_BOOK_PACKAGE_GUEST: "package/guest/createBookingPackage",
};
